export const GET_NOTIFICATION_EVENT = 'GET_NOTIFICATION_EVENT';
export const GET_NOTIFICATION_TYPE = 'GET_NOTIFICATION_TYPE';
